import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useLang } from '../../util/lang';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../store/Global/global';

export default function GlobalDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const get = useLang('');
    const dispatch = useDispatch();
    const globalReducer = useSelector((state) => state.globalReducer);
    const { modalOpen, modalMessage, modalTitle, modalCallbackFunc, modalOnCloseCallbackFunc, showOk, showClose } =
        globalReducer;

    const handleClose = () => {
        if (modalOnCloseCallbackFunc && typeof modalOnCloseCallbackFunc === 'function') {
            modalOnCloseCallbackFunc();
        }
        dispatch(closeModal());
    };

    const handleOk = () => {
        if (!modalCallbackFunc) {
            console.info('No callback function provided');
            handleClose();
            return;
        }
        try {
            modalCallbackFunc();
        } catch (error) {
            console.error(error);
        } finally {
            handleClose();
        }
    };

    if (!modalOpen) {
        return null;
    }

    return (
        <div>
            <Dialog
                open={modalOpen}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{modalTitle || ''}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{modalMessage || ''}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    {showOk && (
                        <Button
                            onClick={handleOk}
                            variant="contained"
                            color="primary"
                            style={{ backgroundColor: '#0080FF', color: 'white' }}
                        >
                            {get(':const.yes')}
                        </Button>
                    )}

                    {showClose && <Button onClick={handleClose}>{get(':const.close')}</Button>}
                </DialogActions>
            </Dialog>
        </div>
    );
}
